<template>
<div>
    <div v-if="!isLoading">
        <div class="w-400px mg-auto">
            <p class="bold dp-inblock h-30px font-23 mt-20">{{popup_title}}</p>

            <div class="mt-30">
                <p v-html="popup_contents"></p>
            </div>
        </div>
        <div class="w-100per txt-center mt-40 mb-40">
            <button class="admin-btn-default" @click="exit()">닫기</button>
        </div>
    </div>
    <div v-else>
        <loading></loading>
    </div>
</div>
</template>

<script>
import Loading from '@/components/loading.vue'
export default {
    components: {
        Loading: Loading
    },
    data: () => ({
        popup_title: '',
        popup_contents: '',
        title: '',
        isLoading: false
    }),

    mounted() {
        this.isLoading = true
        var oParams = this.getUrlParams()
        // console.log('oParams', oParams)
        if (typeof oParams.mainIdx !== 'undefined') {
            var mainIdx = oParams.mainIdx
            var params = {
                mainIdx: mainIdx
            }
        }

        this.axios.get(this.axios.root + this.axios.port + `/sugang/popup/${mainIdx}`, {
                params: params
            })
            .then(res => {
                // console.log('res', res)
                this.isLoading = false
                if (res.data.err === 0) {
                    this.popup_title = res.data.popup.popup_title
                    this.popup_contents = res.data.popup.popup_contents
                    this.title = res.data.title
                    document.title = this.title
                } else {
                    alert(res.data.result)
                    // window.close()
                }
            }).catch(err => {
                this.isLoading = false
                alert(err)
                // window.close()
                // console.log(err)
            })
    },

    methods: {
        // url 파라미터 오브젝트화
        getUrlParams() {
            var params = {}
            window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (str, key, value) {
                params[key] = value
            })
            return params
        },

        exit() {
            window.close()
        }
    }
}
</script>
